import { createRoot } from 'react-dom/client';

import '@src/libs/smoothScroll';

import HeaderNav from '@src/components/HeaderNav';

createRoot(document.querySelector('#headerNav')).render(<HeaderNav />);

